// standart react component
import React from 'react';
import './App.css';
import './index.css';

export default function Titlebar(props) {
    const title = props.title;

  const now = props.nowPlaying;
  const nowText = now && (now.artist || now.title) ? `${now.artist || ''}${now.artist && now.title ? ' - ' : ''}${now.title || ''}` : '';

    return (
        <div className="bg-blue-200 left-0 right-0 my-0 top-16 z-10">            
            <div className="mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8">
              <div className="grid grid-cols-2 items-center">
                <div className="text-3xl font-bold text-gray-900">{title}</div>
                <div className="text-right">
                  {props.rundate}
                  {nowText ? (
                    <div className="text-sm text-gray-700 mt-1">
                      <div>Now Playing: {nowText}</div>
                      <div className="mt-1">
                        <a href="https://ice25.securenetsystems.net/KYKR2" target="_blank" rel="noopener noreferrer" className="text-sm text-indigo-600 hover:underline">monitor</a>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
        </div>
    );
}